import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

export const loadOrderDetail = create(actions.LOAD_ORDER_DETAIL_DATA);
export const setOrderDetailStatus = create(actions.SET_ORDER_DETAIL_STATUS);
export const setOrderDetailData = create(actions.SET_ORDER_DETAIL_DATA);
export const fileDownload = create(actions.FILE_DOWNLOAD);
